import { netsparkAxios } from 'core/services/HTTPService';
import getCustomersListUrl from './apiUrls';

const getCustomersList = (signal, params) => netsparkAxios
  .get(getCustomersListUrl, { signal, params });

export default getCustomersList;
